import React, { useState, useEffect } from 'react';
import ContentContainer from '../../components/ContentContainer/ContentContainer';
import { API, API_ROUTER } from "../../api";
import { useParams } from "react-router-dom";

import s from '../../comon/ComonAdmin.module.scss';
//обнуляющие стили
import "../../comon/_null_style.css";

//компоненты, из которых состоит страница 
import ProfilePanel from '../../components/AdminComponents/ProfilePanelComponent/index';
import HeaderAdmin from '../../components/AdminComponents/header-admin';
import CreateEvent from '../../components/AdminComponents/CreateEvent/index';
import InfoPanel from '../../components/AdminComponents/InfoPanel/index';

//const
import { pageInfo, } from "./const";
import { profileInfo, pageMenu, itemConstArray, btnTournamentsObj, uploadImg, convertDateISO8601 } from "../../comon/comonConst";

/* import TournamentList from '../../components/AdminComponents/Tournament-list/Tournament-list'; */


const EditEvent = (props) => {
   const [itemArray, setItemArray] = useState(itemConstArray);

   // console.log(window.location.href);
   useEffect(() => {
      API.request({
         ...API_ROUTER.Tournaments.getTournaments, pathKeys: {
            page: 1,
            limit: 9999,
         }
      })
         .then((res) => {
            setItemArray(res.tournaments || itemConstArray);
         })
         .catch((err) => console.log(err));
   }, []);

   return (
      <div className={s.evensPageContainer}>
         <ProfilePanel
            pageInfo={pageInfo}
            profileInfo={profileInfo} />
         <ContentContainer
            MainBlock={null}
            MainCreateBlock={true}
         >
            {/* <HeaderAdmin
               pageName={pageInfo.pageName}
               toROUTER={pageInfo.toROUTER}
               addBtn={pageInfo.addBtn}
               periodContainer={pageInfo.periodContainer}
               btnInfo={pageInfo?.btnInfo}
               filter={pageInfo.filter}
               setActiveBtn={setActiveBtn}
               activeBtn={activeBtn}
               onChangeActiveBtn={onChangeActiveBtn}
            /> */}
            <CreateEvent
               convertDateISO8601={convertDateISO8601}
               uploadImg={uploadImg}
            // editEvent={editEvent}
            />
         </ContentContainer>
         {/* <TournamentList
            itemArray={itemArray}
            pageMenu={pageMenu}
            btnObj={btnTournamentsObj}
         /> */}
      </div>
   )
}
export default EditEvent;